import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import SignatureCollection from "../components/SignatureCollection";
import { collections, feature } from "../data/site";

export default function Collections() {
  return (
    <>
      <PageHero
        eyebrow="The Collections"
        title="Curated for every occasion"
        subtitle="From everyday antique gold to regal bridal heritage — three signature expressions of the Culture Antique house."
        image={feature.heroCollections}
      />

      {/* Alternating collection rows */}
      <section className="py-16 md:py-28">
        <div className="container-luxe space-y-20 md:space-y-32">
          {collections.map((c, i) => (
            <div
              key={c.id}
              className={`grid items-center gap-10 lg:grid-cols-2 lg:gap-20 ${
                i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
              }`}
            >
              <Reveal className="overflow-hidden">
                <img
                  src={c.image}
                  alt={c.name}
                  className="h-[400px] w-full object-cover sm:h-[500px] lg:h-[600px]"
                />
              </Reveal>
              <Reveal delay={150}>
                <p className="eyebrow mb-5">0{i + 1} — Collection</p>
                <h2 className="section-title mb-6">{c.name}</h2>
                <p className="max-w-md font-sans text-base font-light leading-relaxed text-charcoal/70">
                  {c.blurb}
                </p>
                <Link to="/contact" className="btn-gold mt-9">
                  Enquire
                </Link>
              </Reveal>
            </div>
          ))}
        </div>
      </section>

      {/* Signature antique gold panels */}
      <SignatureCollection />
    </>
  );
}
